import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import PlainModal from '../../../../components/modal/PlainModal'
import InputComponent from '../../../../components/ui/InputComponent'

interface CancelReservationProps {
  open: boolean
  handleClose: () => void
  onCancel: () => void
  onHandleConfirm: (reason: string) => void
}

const CancelReservation: React.FC<CancelReservationProps> = ({
  open,
  handleClose,
  onCancel,
  onHandleConfirm,
}) => {
  const [reason, setReason] = useState('')
  return (
    <PlainModal
      open={open}
      handleClose={handleClose}
      modelWidth="450px"
      title="Cancel Reservation"
      actionButtonName="Confirm"
      cancelButtonName="Cancel"
      onAction={() => onHandleConfirm(reason)}
      onCancel={onCancel}
    >
      <Box>
        <Typography variant="subtitle1" mb={1}>
          Could you kindly share the reasons for your decision to cancel the
          reservation?
        </Typography>
        <InputComponent
          value={reason}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setReason(e.target.value)
          }
          rows={4}
          sx={{
            mb: 2,
          }}
          multiline
          placeholder="Enter your reason"
        />
      </Box>
    </PlainModal>
  )
}

export default CancelReservation
